module.exports = __webpack_public_path__ + "img/firstNameEle.c8e67a68.svg";